// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const createQueryKeys = <TEntity extends string>(entity: TEntity) => ({
    all: [entity] as const,
    lists: () => [entity, 'list'] as const,
    list: <TFilters>(filters?: TFilters) => [entity, 'list', {filters}] as const,
    details: () => [entity, 'detail'] as const,
    detail: (id: string | number) => [entity, 'detail', id] as const,
    sub: <T extends unknown[]>(...subKeys: T): [TEntity, ...T] => [entity, ...subKeys],
});

const _user = createQueryKeys('users');
const _codebook = createQueryKeys('codebooks');
const _connection = createQueryKeys('connections');
const _analytics = createQueryKeys('analytics');
const _conversation = createQueryKeys('conversations');
const _auth = createQueryKeys('auth');
const _presentationPrototype = createQueryKeys('presentationPrototype');

export const QUERY_KEYS = {
    presentation: createQueryKeys('presentations'),
    sharedPresentation: createQueryKeys('sharedPresentations'),
    feed: createQueryKeys('presentationsFeed'),
    theme: createQueryKeys('themes'),
    room: createQueryKeys('rooms'),
    roomsForPresentation: createQueryKeys('roomsForPresentation'),
    calculator: createQueryKeys('calculators'),
    notification: createQueryKeys('notifications'),
    messageConnection: createQueryKeys('messageConnections'),
    user: {
        ..._user,
        config: (id: string) => _user.sub('config', id),
        defaultConfig: () => _user.sub('defaultConfig'),
    },

    codebook: {
        ..._codebook,
        entries: (codebookId: string, search: string) => _codebook.sub('entries', codebookId, {search}),
    },
    connection: {
        ..._connection,
        received: <TFilters>(filters?: TFilters) => _connection.sub('received', {filters}),
        sent: <TFilters>(filters?: TFilters) => _connection.sub('sent', {filters}),
    },
    analytics: {
        ..._analytics,
        base: (presId: string, filter: unknown) => _analytics.sub('base', presId, filter),
        topSlides: (presId: string, filter: unknown) => _analytics.sub('topSlides', presId, filter),
        topTime: (presId: string, filter: unknown) => _analytics.sub('topTime', presId, filter),
    },
    conversation: {
        ..._conversation,
        messages: (conversationId: string) => _conversation.sub('messages', conversationId),
        unseen: (conversationId: string) => _conversation.sub('unseen', conversationId),
    },
    auth: {
        ..._auth,
        loggedInUser: () => _auth.sub('loggedInUser'),
        usersForConnection: <TSearch>(paginatedSearch: TSearch) => _auth.sub('usersForConnection', paginatedSearch),
    },
    presentationPrototype: {
        ..._presentationPrototype,
        promptHistory: (id: string) => _presentationPrototype.sub('promptHistory', id),
    },
};
